module.exports = __webpack_public_path__ + "static/media/TEMPLATE_2.02eec004.webp";